export class WorkDay {
  constructor(workDay = {}) {
    this.dayOfTheWeek = workDay.day_of_week;
    this.opensAt = workDay.opens_at;
    this.closesAt = workDay.closes_at;
  }
}
